(() => {
  if (window.__amaliaFastCartInstalled) return;

  window.__amaliaFastCartInstalled = true;
  const nativeFetch = window.fetch.bind(window);
  let cachedCartSection = '';

  window.fetch = async (input, options = {}) => {
    const url = typeof input === 'string' ? input : input.url;
    const isCartChange = url.includes('/cart/change');
    const isCartSectionRequest = url.includes('section_id=api-cart-items');

    if (isCartSectionRequest && cachedCartSection) {
      const section = cachedCartSection;
      cachedCartSection = '';
      return new Response(section, {
        status: 200,
        headers: {'Content-Type': 'text/html; charset=utf-8'},
      });
    }

    if (isCartChange && typeof options.body === 'string') {
      try {
        const body = JSON.parse(options.body);
        body.sections = 'api-cart-items';
        body.sections_url = window.location.pathname;
        options = {...options, body: JSON.stringify(body)};
      } catch (error) {
        // Keep the theme's native request unchanged if its payload is not JSON.
      }
    }

    const response = await nativeFetch(input, options);

    if (isCartChange && response.ok) {
      try {
        const state = await response.clone().json();
        cachedCartSection = state.sections?.['api-cart-items'] || '';
      } catch (error) {
        cachedCartSection = '';
      }
    }

    return response;
  };
})();

!function(){"use strict";customElements.get("quantity-counter")||customElements.define("quantity-counter",class extends HTMLElement{constructor(){super()}connectedCallback(){this.input=this.querySelector("input"),this.changeEvent=new Event("change",{bubbles:!0}),this.buttonClickEvent=this.onButtonClick.bind(this),this.onQuantityChangeEvent=this.onQuantityChange.bind(this),this.input.addEventListener("change",this.onQuantityChangeEvent),this.querySelectorAll("button").forEach((t=>t.addEventListener("click",this.buttonClickEvent)))}onButtonClick(t){t.preventDefault();const e=this.input.value,n="BUTTON"==t.target.nodeName?t.target:t.target.closest("button");"increase"===n.name&&this.input.stepUp(),"decrease"===n.name&&this.input.stepDown(),e!==this.input.value&&this.input.dispatchEvent(this.changeEvent)}onQuantityChange(){"updates[]"==this.input.name&&this.updateCart()}updateCart(){""!==this.quantityValue&&this.dispatchEvent(new CustomEvent("theme:cart:update",{bubbles:!0,detail:{id:this.input.dataset.id,quantity:this.input.value}}))}})}();
